import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const LOGO = "https://customer-assets.emergentagent.com/job_admissions-roadmap/artifacts/2ac8oce6_Mindways%20logo.png";

export default function PrivacyPolicy() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div style={{ minHeight: "100vh", backgroundColor: "#fff" }}>
      {/* Header */}
      <header style={{ backgroundColor: "#2B2F9E", padding: "20px 24px" }}>
        <div style={{ maxWidth: "1280px", margin: "0 auto", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <Link to="/">
            <div style={{ backgroundColor: "#fff", borderRadius: "8px", padding: "6px 12px" }}>
              <img src={LOGO} alt="Mindways" style={{ height: "52px", width: "auto", display: "block" }} />
            </div>
          </Link>
          <Link to="/" style={{ color: "rgba(255,255,255,0.85)", fontFamily: "'DM Sans', sans-serif", fontSize: "14px", fontWeight: "600", textDecoration: "none" }}>
            &larr; Back to Home
          </Link>
        </div>
      </header>

      {/* Content */}
      <main style={{ maxWidth: "800px", margin: "0 auto", padding: "64px 24px" }}>
        <span style={{ fontSize: "13px", fontWeight: "700", letterSpacing: "0.12em", textTransform: "uppercase", color: "#F5A000", fontFamily: "'DM Sans', sans-serif" }}>Legal</span>
        <h1 style={{ fontFamily: "'Playfair Display', serif", fontSize: "clamp(28px, 4vw, 42px)", fontWeight: "700", color: "#0F172A", margin: "12px 0 8px", lineHeight: "1.2" }}>Privacy Policy</h1>
        <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: "14px", color: "#94A3B8", marginBottom: "48px" }}>Last updated: February 2026</p>

        {[
          {
            title: "1. Who We Are",
            body: "Mindways Consulting Pvt. Ltd. ('Mindways', 'we', 'us', 'our') is an overseas education consultancy registered in New Delhi, India. Our registered office is at 1106 Chiranjiv Tower, 43 Nehru Place, New Delhi 110019. You may contact us at study@mindways.in.",
          },
          {
            title: "2. Information We Collect",
            body: "When you submit our 'Get Shortlist' form or contact us, we collect: your full name, email address, WhatsApp number, study level, academic qualifications and scores, preferred programme and destination, target intake, and any additional message you provide. We also collect standard website analytics data (pages visited, browser type, referring URL) through third-party tools.",
          },
          {
            title: "3. How We Use Your Information",
            body: "We use the information you provide to: prepare and deliver your personalised university shortlist; contact you via email, WhatsApp, or phone to follow up on your enquiry; improve our services and website; and send you relevant information about overseas education opportunities. We do not sell, rent, or trade your personal data to third parties.",
          },
          {
            title: "4. Legal Basis for Processing",
            body: "We process your personal data on the basis of your consent (provided when you submit our form) and our legitimate interest in responding to your enquiry. You may withdraw consent at any time by emailing study@mindways.in.",
          },
          {
            title: "5. Data Retention",
            body: "We retain your personal data for as long as necessary to provide our services and as required by applicable Indian law. If you request deletion of your data, we will do so within 30 days unless retention is required by law.",
          },
          {
            title: "6. Data Security",
            body: "We take reasonable technical and organisational measures to protect your personal data from unauthorised access, disclosure, or loss. Data submitted via our website is stored securely and accessible only to authorised Mindways staff.",
          },
          {
            title: "7. Third-Party Services",
            body: "Our website uses third-party services including Google Analytics (for usage analytics) and Cal.com (for booking appointments). These services have their own privacy policies. We are not responsible for their data practices.",
          },
          {
            title: "8. Your Rights",
            body: "You have the right to: access the personal data we hold about you; request correction of inaccurate data; request deletion of your data; object to processing; and withdraw consent at any time. To exercise any of these rights, email us at study@mindways.in.",
          },
          {
            title: "9. Changes to This Policy",
            body: "We may update this Privacy Policy from time to time. The current version will always be available on this page with the date of last update.",
          },
          {
            title: "10. Contact",
            body: "For privacy-related queries, contact us at: study@mindways.in | +91-9821916960 | 1106 Chiranjiv Tower, 43 Nehru Place, New Delhi 110019.",
          },
        ].map((section) => (
          <div key={section.title} style={{ marginBottom: "36px" }}>
            <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: "20px", fontWeight: "700", color: "#0F172A", margin: "0 0 12px" }}>{section.title}</h2>
            <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: "16px", color: "#475569", lineHeight: "1.75", margin: 0 }}>{section.body}</p>
          </div>
        ))}
      </main>

      {/* Footer strip */}
      <div style={{ backgroundColor: "#2B2F9E", padding: "24px", textAlign: "center" }}>
        <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: "13px", color: "rgba(255,255,255,0.6)", margin: 0 }}>
          © {new Date().getFullYear()} Mindways Consulting Pvt. Ltd. · <Link to="/terms-of-service" style={{ color: "rgba(255,255,255,0.6)", textDecoration: "none" }}>Terms of Service</Link> · <Link to="/cookie-policy" style={{ color: "rgba(255,255,255,0.6)", textDecoration: "none" }}>Cookie Policy</Link>
        </p>
      </div>
    </div>
  );
}
